<section class="quote-progress" aria-label="Selected quote">
  <h5 class="quote-progress__heading" data-testid="selected-quote-heading">
    SELECTED QUOTE
  </h5>
  <div class="quote-progress__vendor-header">
    <span class="quote-progress__vendor">{{ vendorName() }}</span>
    <button
      type="button"
      class="quote-progress__download"
      aria-label="View Quote PDF"
      (click)="generateQuotePDF()"
    >
      View Quote PDF
    </button>
  </div>

  @if (hasAnyReclassification()) {
    <div
      class="quote-progress__reclassification-banner"
      role="alert"
      data-testid="job-requirement-change-banner"
    >
      <mat-icon class="quote-progress__banner-icon" aria-hidden="true"
        >info</mat-icon
      >
      <p class="quote-progress__banner-text">
        <strong>Job Requirement Change:</strong> While reviewing your files for
        translation, the vendor identified some changes regarding Desktop
        Publishing needs. If you select this quote, these changes will be
        reflected in the Job Details tab. For more details please expand the
        Document Requirement Changes accordion.
      </p>
    </div>
  }

  <!-- Card -->
  <div class="quote-progress__card">
    <!-- Info row -->
    <div class="quote-progress__info">
      <div class="quote-progress__info-col">
        <span class="quote-progress__info-label">Delivery type</span>
        <span class="quote-progress__info-value">
          <mat-icon
            class="quote-progress__clock-icon"
            [svgIcon]="deliveryType() === 'Rushed' ? 'bolt' : 'pace'"
            aria-hidden="true"
          ></mat-icon>
          {{ deliveryType() }}
        </span>
      </div>
      <div class="quote-progress__info-col">
        <span class="quote-progress__info-label">Delivery date</span>
        <span
          class="quote-progress__info-value quote-progress__info-value--bold"
          >{{ deliveryDate() }}</span
        >
      </div>
      <div class="quote-progress__info-col">
        <span class="quote-progress__info-label">Quote ID</span>
        <span
          class="quote-progress__info-value quote-progress__info-value--bold"
          >{{ quoteId() }}</span
        >
      </div>
    </div>

    <!-- Cost breakdown -->
    @if (costBreakdown().length) {
      <div class="quote-progress__breakdown">
        @for (item of costBreakdown(); track item.concept) {
          <div class="quote-progress__breakdown-row">
            @if (item.concept === "Translation cost") {
              <span class="quote-progress__breakdown-concept">
                Estimated linguistic review
              </span>
            } @else {
              <span class="quote-progress__breakdown-concept">{{
                item.concept
              }}</span>
            }
            <span class="quote-progress__breakdown-cost">{{
              item.cost | formatCurrency: currency()
            }}</span>
          </div>
        }
        <div class="quote-progress__total-row">
          <span class="quote-progress__total-label">Total cost</span>
          <span class="quote-progress__total-value">
            {{ totalCost() | formatCurrency: currency() }}
          </span>
        </div>
      </div>
    }

    <!-- 15% buffer note -->
    <p class="quote-progress__buffer-note">
      <strong>Note:</strong> Add a 15% buffer to your purchase order to account
      for potential adjustments in currency, tax, or review costs after file
      preparation.
    </p>

    <!-- Recommended PO Total -->
    <div class="quote-progress__recommended">
      <span class="quote-progress__recommended-label"
        >Recommended PO total</span
      >
      <span class="quote-progress__recommended-value">
        <span class="quote-progress__recommended-pct">+15%</span>=
        {{ recommendedPOTotal() | formatCurrency: currency() }}
      </span>
    </div>
  </div>

  <!-- Purchase Order -->
  <span class="quote-progress__purchase-order">
    <span class="quote-progress__purchase-order-label">Purchase Order:</span>
    <span class="quote-progress__purchase-order-value">{{
      purchaseOrderId()
    }}</span>
  </span>

  <app-document-requirement-changes [detail]="vendorJobDetails()" />

  <app-previous-quotes
    [estimates]="approvedPreviousEstimates()"
    [order]="order()"
    [selectedEstimate]="vendorEstimate()"
    [lowestCostId]="lowestCostId()"
    [showTopBorder]="showPreviousQuotesTopBorder()"
  />
</section>
